<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
body {
  display: flex;
  justify-content: center;
  text-align: center;
  width: 100%;
  margin: 0 auto;
  padding: 0;
}
.menuhov {
  color: #c8def2;
  font-family: "宋体";
}
.menuhov:hover {
  color: #fff !important;
  text-decoration: underline !important;
  text-decoration-thickness: 0.5px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue